import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { deleteAxiosResponse, getAxiosResponse,getAxiosResponseAndSetState,postAxiosResponse, putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { RotatingLines } from "react-loader-spinner";
import Constants from "../../../Constants";
import Select from "react-select";
import { encodePassword, transformBlankToNull } from "../../../services/Util";
import { useParams,Link, useNavigate } from "react-router-dom";
import { getLoggedInUserRole, openNewTab } from "../../../services/Util";
import ReactTooltip from "react-tooltip";
import $ from "jquery";
import { useTranslation } from "react-i18next";
import { rolePermissionSelected } from '../../../redux/reducers/RolePermissionSlice';
import { ConditionalBlock } from '../../../ConditionalBlock';

export default function Profile(prop) {

  const { t } = useTranslation();
  const translate = t;

  const owner = useSelector(
    (reduxStore) => reduxStore.loginSession
  ).value;

  const customerBootstrapData = useSelector(reduxStore => reduxStore.customer_bootstrap_data).value;
  const saveRef = useRef(null);
  const profileDeptTooltipRef = useRef(null);
  const editProfileDeptTooltipRef = useRef(null);
  const langToReviewTooltipRef = useRef(null);
  const editLangToReviewTooltipRef = useRef(null);
  const langToTranslateTooltipRef = useRef(null);
  const editLangToTranslateTooltipRef = useRef(null);
  const [userDetail, setUserDetail] = useState({});
  const [userGroup, setUserGroup] = useState([]);
  const [defaultSelectedLangs, setDefaultLangs] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const [userOptionalRole, setUserOptionalRole] = useState([]);
  const [targetLangReview, setTargetLangReview] = useState([]);
  const [allTargetLangs,setAllTargetLangs] = useState([])
  const [selectedTargetLangReview, setSelectedTargetLangReview] = useState([]);
  const serviceType = [
    { label: "Select", value: "" },
    { label: "MARKETO", value: "MARKETO" },
    { label: "MARKETO REST", value: "MARKETOREST" },
  ];
  const [allSourceLangs, setAllSourceLangs] = useState([]);
  const [updated, setPairUpdated] = useState(false);
  const [sourceLanguage, setSourceLanguage] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [selectedUserRole, setSelectedUserRole] = useState({});
  const [defaultSelectedReview, setDefaultSelectedReview] = useState([]);
  const [selectedUserOptionalRole, setSelectedUserOptionalRole] = useState({});
  const [hideOptionalRole, setHideOptionalRole] = useState(false);
  const [userLangPair, setUserLangPair] = useState([]);
  const [displayUserLangPair, setDisplayUserLangPair] = useState([]);
  const [selectedSourceLang, setSelectedSourceLang] = useState([]);
  const [selectedTargetLang, setSelectedTargetLang] = useState([]);
  const [targetLanguages, setTargetLanguage] = useState([]);
  const [showTargetLang, setShowTargetLang] = useState("");
  const [selectedLanguagecode, setSelectedLanguageCode] = useState("");
  const [password, setPassword] = useState("");
  const [invalidPasswordError, setInvalidPasswordError] = useState(false);
  const [successErrors, setSuccessErrors] = useState(false);
  const [successErrorMsg, setSuccessErrorMsg] = useState("");
  const [customerData, setCustomerData] = useState({});
  const [showEmailChangeConfirmation, setShowEmailChangeConfirmation] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationCodeError, setVerificationCodeError] = useState(false);
  const [codeResent, setCodeResent] = useState(false);
  const [ownerRole, setOwnerRole] = useState("");
  const [companyEmail, setCompanyEmail] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [allDepartments, setAllDepartments] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([{label: "--Select a department--", value: Constants.BLANK}, {label: "--Select All--", value: Constants.ALL}]);

  const params = useParams();
  const navigate = useNavigate();
  const userId = params.id !== undefined ? params.id : owner.id ;
  const [addclass, changeclass] = useState(params.id !== undefined ? true : false);
  const [errorMessage, setErrorMessage] = useState('');
  const [hasError, setHasError] = useState(false);
  const [refs, setRefs] = useState({});

  const userPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;

  function showModel() {
    document.body.classList.add("modal-open");
    setPassword("");
  }

  function hideModel() {
    document.body.classList.remove("modal-open");
  }

 const roleArray = getLoggedInUserRole();
  const fetchUserRoles = () => {
    getAxiosResponse(APIUrls.USER_ROLES).then((res) => {
      const options = [];
      res.data.data.map((role) =>
        options.push({
          label: role.displayName,
          value: role,
        })
      );
      setUserRole(options);
    });
  };
  const removeDepartment = (depart) => {
    var newDeparts = [];
    newDeparts = userGroup.filter(function (option) {
      return option.userGroup.id !== depart.userGroup.id || option.userGroup.value !== depart.userGroup.value;
    });
    setUserGroup(newDeparts)
    let deptToBeAdded;
    if(depart.userGroup.value === undefined) {
      deptToBeAdded = {label : depart.userGroup.name, value : depart.userGroup.id};
    } else {
      deptToBeAdded = depart.userGroup;
    }
    setFilteredDepartments((filteredDepartments) => [...filteredDepartments, deptToBeAdded]);
    
    if($(document.activeElement).closest('tbody').children().length === 1){
      $(document.activeElement).closest('.profile-department').find(':input:first').trigger('focus');
    } else if($(document.activeElement).closest('tr').is(':last-child')){
      $(document.activeElement).closest('tr').prev().find('td:first button:first').trigger('focus');
    }
  };
  const removeLanguagePairSource = (val) => {
    var value = val.source;
    setUserLangPair((current) =>
      current.filter((userLangPair) => userLangPair.source !== value.language)
    );
    var filter = allSourceLangs.filter(
      (allSourceLangs) => allSourceLangs.value.language === value.language
    )[0];
    setSourceLanguage((current) => [...current, filter]);

    var displayFilter = displayUserLangPair.filter((langs)=>{
      return langs.source.code !== value.code
    })
    setDisplayUserLangPair(displayFilter)
    const selectedElement = $(document.activeElement).closest("ul");
    if($(document.activeElement).closest('div').is(':last-child') &&
    selectedElement.children().length > 1){
      selectedElement.find('.pairFromBtn').eq(-2).trigger('focus');
    } else if($(document.activeElement).closest('div').is(':last-child')){
      $(document.activeElement).closest(".multiselect-output").next().find('.global-dropdown-select input').trigger('focus');
    }
  };
  const setProjectForBlockedUser = (val) =>{

  }
  const removeLanguagePairTarget = (source, target) => {
    var copyDisplayLangPair = structuredClone(displayUserLangPair)
    var pair = userLangPair.filter((e)=> {
      return e.target !== target.language;
    });
    copyDisplayLangPair.forEach((e)=> {
      if(source.source.code === e.source.code){
        var filterTrgt= e.target.filter((targt)=>{
          return targt.code !== target.code
        })
        source.target = filterTrgt
      }
    });
    setUserLangPair(pair)
  };
  const setOptionlRoleVales = (selectedRole) => {
    if (
      selectedRole?.value?.value === "ROLE_CUSTOMER" ||
      selectedRole?.value?.value === "ROLE_CUSTOMER_PROJECT_MANAGER"
    ) {
      let optionalRole = [{ label: "None", value: { value: "none" } }];
      setUserOptionalRole(optionalRole);
      optionalRole.push(
        userRole.filter(function (option) {
          return option.value.value === "ROLE_CUSTOMER_INTERNAL_TRANSLATOR";
        })[0]
      );
      setUserOptionalRole(optionalRole);
      setHideOptionalRole(customerBootstrapData?.features?.USER_GROUPS ? false : true);
    }
    if (selectedRole?.value?.value === "ROLE_CUSTOMER_INTERNAL_TRANSLATOR") {
      let optionalRole = [{ label: "None", value: { value: "none" } }];
      setUserOptionalRole(optionalRole);
      
      let filterdRole = userRole.filter(function (option) {
        return (
          option.value.value === "ROLE_CUSTOMER" ||
          option.value.value === "ROLE_CUSTOMER_PROJECT_MANAGER" ||
          option.value.value === "ROLE_CUSTOMER_REVIEWER"
        );
      });

      filterdRole.map((roles) => {
        setUserOptionalRole((oldArray) => [...oldArray, roles]);
      });
      setHideOptionalRole(customerBootstrapData?.features?.USER_GROUPS ? false : true);
    }
    if (selectedRole?.value?.value === "ROLE_CUSTOMER_PROJECT_REQUESTER") {
      let optionalRole = [{ label: "None", value: { value: "none" } }];

      optionalRole.push(
        userRole.filter(function (option) {
          return option.value.value === "ROLE_CUSTOMER_REVIEWER";
        })[0]
      );
      setUserOptionalRole(optionalRole);
      setHideOptionalRole(customerBootstrapData?.features?.USER_GROUPS ? false : true);
    }
    if (selectedRole?.value?.value === "ROLE_CUSTOMER_QUOTE_APPROVER") {
      let optionalRole = [{ label: "None", value: { value: "none" } }];
      setUserOptionalRole(optionalRole);
      setSelectedUserOptionalRole({});
      setHideOptionalRole(customerBootstrapData?.features?.USER_GROUPS ? true : false);
    }
    if (selectedRole?.value?.value === "ROLE_CUSTOMER_REVIEWER") {
      let optionalRole = [{ label: "None", value: { value: "none" } }];
      setUserOptionalRole(optionalRole);
      let filterdRole = userRole.filter(function (option) {
        return (
          option.value.value === "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
          option.value.value === "ROLE_CUSTOMER_PROJECT_REQUESTER"
        );
      });
      filterdRole.map((roles) => {
        setUserOptionalRole((oldArray) => [...oldArray, roles]);
      });
      setHideOptionalRole(customerBootstrapData?.features?.USER_GROUPS ? false : true);
    }
  };
  const filterUsers = (value) => {
    var selectedRole = value;
    let optionalRole = [{ label: "None", value: { value: "none" } }];
    setSelectedUserOptionalRole(optionalRole);
    setOptionlRoleVales(value);
    setSelectedUserRole(selectedRole);
  };
  const filterOptionalUser = (value) => {
    setSelectedUserOptionalRole(value);
  };
  const selectServiceType = (value) => {
  };
  
  const selectTargetLangKeydown = (e, lang, index) => {
    if (e.key===Constants.ENTER) {
      selectTargetLang(e, lang, index);
    }
  }
  const selectTargetLang = (e, lang, index) => {
    if($('.setTop').hasClass('show-assignee-dropdown')){
       $('.my-account-page').removeClass('pb-120')
    }
    else{
      $('.my-account-page').addClass('pb-120')
    }
  
    var sourceLang = lang.source
    var result = [];
    var resultSource = [];
    result = allTargetLangs.filter(
      ({ value: id1 }) => !lang.target.some((id2) => id2.code === id1.code)
    );
    resultSource = result.filter(function (res) {
      return res.value.code !== sourceLang.code;
   })
    setTargetLanguage(resultSource);
    
    showTargetLang === index ? setShowTargetLang("") : setShowTargetLang(index);
    
  };

  const selectNewSourceLang = (value) => {
    var newSource = {
      customerId: 3005,
      source: value.value.language,
      target: null,
      userId: userId,
    };
    setUserLangPair((current) => [...current, newSource]);
    var newPair = { source: value.value, target: [] };
    setDisplayUserLangPair((current) => [...current, newPair]);

    setSourceLanguage((current) =>
      current.filter(
        (sourceLanguage) =>
          sourceLanguage.value.code !== value.value.code
      )
    );
    setSelectedSourceLang(value);
  };

  const selectNewTargetLang = (target, source) => {
      var newTarget= {
        customerId: 3005,
        source: source.source.language,
        target: target.value.language,
        userId: userId,
      };
      setUserLangPair((current) => [...current, newTarget]);
      var index = displayUserLangPair.findIndex(
        (x) => x.source === source.source
      );
      setSelectedLanguageCode(target.value.language + "-" + index);
      var copy = displayUserLangPair;
      setTargetLanguage((current) =>
      current.filter(
        (targetLanguage) =>
        targetLanguage.value.code !== target.value.code
      ))
      copy[index].target.push(target.value);
      
      setDisplayUserLangPair(copy);
      setTimeout(() => {
        setShowTargetLang("");
        $('.my-account-page').removeClass('pb-120')
      }, 500);
  };

  const selectTargetLangReview = (value) => {
    var targetLangs = JSON.parse(JSON.stringify(allTargetLangs))
    targetLangs.shift();
    
    if(value.value === 'all'){
      targetLangs.map((target)=>{
        setDefaultSelectedReview((current)=>[...current,target.value])
      })
      
      setSelectedTargetLang(targetLangs)
    }else{
      setSelectedTargetLang(value)
      setDefaultSelectedReview((current)=>[...current,value.value])
    }
  };

  const getSourceLanguage = () => {
    getAxiosResponse(APIUrls.SOURCE_LANGUAGE)
      .then((res) => {
        var sourceLang = [];
        if (res.data.code === 200) {
          res.data.data.map((source) => {
            sourceLang.push({
              label: source.display,
              value: source,
            });
          });
          setAllSourceLangs(sourceLang);
          if(userLangPair !== ''){ 
          var selectedlang = sourceLang.filter(function (cv) {
            return !userLangPair.find(function (e) {
              return e.source === cv.value.language;
            });
          });
          setSourceLanguage(selectedlang)
        }
        $('#addAnotherRole').prev().attr('for', $('#addAnotherRole input').attr('id'));
        }
      })
  };
  const getFullUserById = () =>{
    getAxiosResponse(APIUrls.GET_FULL_USER_BY_ID_COMBINED(userId))
      .then((res) => {
        if(res.data.status=== 'success'){
        let langPair = [];
        setUserDetail(res.data.data?.resource);
        setDefaultLangs(res.data.data?.resource?.userLanguages);
        setUserGroup(res.data.data?.resource?.userGroupMembers);
        if(!roleArray.includes('ROLE_VENDOR')){
          fetchUserRoles()
        }
        setSelectedUserRole({ value: res.data.data?.resource?.roleSet?.roleTypes[0] });
        
        setSelectedUserOptionalRole({
          value: res.data.data?.resource?.roleSet?.roleTypes[1],
        });

        if ( res?.data?.data?.displayName && res?.data?.data?.displayName[0]?.userLanguagePair?.length !== 0) {
          res.data.data?.displayName[0]?.userLanguagePair?.map((pairLanguage, index) => {
            if (index === 0) {
              langPair.push({
                source: pairLanguage.source[0],
                target: [pairLanguage.target[0]],
              });
            } else {
              if (
                langPair[langPair.length - 1].source.code === pairLanguage.source[0].code
              ) {
                langPair[langPair.length - 1].target.push(pairLanguage.target[0]);
              } else {
                langPair.push({
                  source: pairLanguage.source[0],
                  target: [pairLanguage.target[0]],
                });
              }
            }
            setDisplayUserLangPair(langPair);
          });
          setUserLangPair(res.data.data?.resource.userLanguagePairs);
        }
      }
      })
  }

  const getCustomerData = () => {
    getAxiosResponseAndSetState(APIUrls.GET_CUSTOMER_INFORMATION, setCustomerData)
  }

  const getAllAvailableDepartments = () => {
    getAxiosResponse(APIUrls.AVAILABLE_DEPARTMENTS)
    .then((res) => {
      let options = res.data.data.map((dept) => ({
          label: dept.name,
          value: dept.id
      }))
      setAllDepartments(options);
    })
  }

  const handleDepartmentSelection = (selectedDept) => {
    if(selectedDept.value !== Constants.BLANK && selectedDept.value !== Constants.ALL) {
      let userGroupToBeAdded = {
        applicationVersion : "",
        availableAsInternalTranslator : false,
        customer : "",
        defaultFollowAllProjects : false,
        includeInFollowersList : true,
        path : "",
        userGroup : selectedDept
      }
      setUserGroup((userGroup) => [...userGroup, userGroupToBeAdded])
      let filteredDepts = filteredDepartments.filter((dept) => dept.value !== selectedDept.value);
      setFilteredDepartments(filteredDepts);
    } else if (selectedDept.value === Constants.ALL) {
      let filteredDepts = filteredDepartments.filter((dept) => dept.value !== Constants.BLANK && dept.value !== Constants.ALL)
      let deptsToBeAdded = []
      filteredDepts.map((dept) => {
        deptsToBeAdded.push(
          {
            applicationVersion : "",
            availableAsInternalTranslator : false,
            customer : "",
            defaultFollowAllProjects : false,
            includeInFollowersList : true,
            path : "",
            userGroup : dept
          }
        )
      })
      setUserGroup((ug) => [...ug, ...deptsToBeAdded]);
      setFilteredDepartments([{label: "--Select a department--", value: Constants.BLANK}, {label: "--Select All--", value: Constants.ALL}]);
    }
  }

  useEffect(() => {
    (prop.openEdit || prop.isEdit()) ? changeclass(true) : changeclass(false);
    getFullUserById();
    if(customerBootstrapData?.features?.USER_GROUPS) {
      getAllAvailableDepartments();
    }
    if(!roleArray.includes('ROLE_VENDOR')){
    getCustomerData();
    fetchUserRoles();
    }
    if(owner !== "") {
      setOwnerRole(owner?.role.find((obj) => obj.value === Constants.ROLE_CUSTOMER_ADMIN)?.value);
    }
  }, []);

  useEffect(() => {
    setOptionlRoleVales(selectedUserRole)
  }, [selectedUserRole])

  
  useEffect(() => {
    if(!roleArray.includes('ROLE_VENDOR')){
    getAxiosResponse(APIUrls.TARGET_LANGUAGE)
      .then((res) => {
        if (res.data.code === 200) {
          var targetLang = [];
          res.data.data.map((targetLangs) => {
            targetLang.push({
              label: targetLangs.display,
              value: targetLangs,
            });
          });
          setAllTargetLangs(targetLang)

          setTargetLanguage(targetLang);
          if (defaultSelectedLangs && defaultSelectedLangs.length !== 0) {
            var filteredRemainingLang = res.data.data.filter(
              ({ language: id1 }) =>
                !defaultSelectedLangs.some(({ language: id2 }) => id2 === id1)
            );
            var filteredAllLang = res.data.data.filter(({ language: id1 }) =>
              defaultSelectedLangs.some(({ language: id2 }) => id2 === id1)
            );

            var tempTargetLang = [];
            filteredRemainingLang.map((langs) => {
              tempTargetLang.push({
                label: langs.display,
                value: langs,
              });
            });
            setTargetLangReview(tempTargetLang);
            setDefaultSelectedReview(filteredAllLang);
          }
        }
      })}
      if(filteredDepartments.length === 2) {
        let selectedDepts = userGroup?.map((ug) => ug.userGroup.id)
        let filteredDepts = allDepartments.filter((dept) => !selectedDepts.includes(dept.value));
        setFilteredDepartments((filteredDepartments) => [...filteredDepartments, ...filteredDepts]);
      }
      // userId could be string and owner.id number, which is why == is used instead of ===
      setCompanyEmail(userId==owner.id && userDetail?.requestedEmail === '' && userDetail?.hasFreeEmail === true);
      setVerifyEmail(userId==owner.id && userDetail?.requestedEmail !== ''  && !(userDetail?.requestedEmail === userDetail?.email));
      
      setTimeout(function(){
        $('#firstName').select();
      }, 300);
  }, [userDetail]);
  
  const editclick = (e) => {
    setOptionlRoleVales(selectedUserRole)
    changeclass(!addclass);
    getSourceLanguage();
    if(params.id !== undefined && e.target.innerHTML === Constants.CANCEL) {
      prop.isEdit(true);
    } else {
      prop.isEdit(false);
    }
    setTimeout(function(){
      $('#firstName').select();
    }, 300);
  };

  const handleCancel = (e) => {
    setHasError(false);
    changeclass(!addclass);
    if(params.id !== undefined && e.target.innerHTML === Constants.CANCEL) {
      prop.isEdit(true);
    } else {
      prop.isEdit(false);
    }

    setTimeout(() => {
      $('#edit-btn').trigger('focus');
    }, 300);
    getFullUserById();

  }

  const removeLanguage = (selected) => {
    var langArray = [];
    langArray.push(selected);
    var result = defaultSelectedReview.filter(
      ({ language: id1 }) => !langArray.some(({ language: id2 }) => id2 === id1)
    );
    setDefaultSelectedReview(result);
    setTargetLangReview((current) => [
      ...current,
      { label: selected.display, value: selected },
    ]);

    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".lang-and-review").find('.wrap-dropdown input:first-of-type').trigger('focus');
    }
  };
  const setUserGroupAccessFollower = (e, val, index) => {
    var newState = userGroup.map((obj) => {
      if (obj.userGroup.id === val.userGroup.id) {
        return { ...obj, includeInFollowersList: e.target.checked };
      }
      return obj;
    });
    setUserGroup(newState);
  };
  const setUserGroupAccessAutomaticFollower = (e, val) => {
    var newState = userGroup.map((obj) => {
      if (obj.userGroup.id === val.userGroup.id) {
        return { ...obj, defaultFollowAllProjects: e.target.checked };
      }
      return obj;
    });
    setUserGroup(newState);
  };
  const setUserGroupAccessInternalTranslator = (e, val) => {
    var newState = userGroup.map((obj) => {
      if (obj.userGroup.id === val.userGroup.id) {
        return { ...obj, availableAsInternalTranslator: e.target.checked };
      }
      return obj;
    });
    setUserGroup(newState);
  };

  const handleUserGroupMemberSettings = () => {
    userGroup.map((ug, index) => {
      if(ug?.userGroup?.value !== undefined || ug?.value !== undefined) {
        let userGroupToBeAdded = {
          applicationVersion : "",
          availableAsInternalTranslator : ug.availableAsInternalTranslator,
          customer : "",
          defaultFollowAllProjects : ug.defaultFollowAllProjects,
          includeInFollowersList : ug.includeInFollowersList,
          path : "",
          userGroup : {
            applicationVersion : null,
            createdDate : null,
            id : ug?.userGroup?.value || ug?.value,
            name : ug?.userGroup?.label || ug?.label,
            path : null,
            systemGroup : false
          }
        }
        userGroup[index] = userGroupToBeAdded;
      }
    })
  }

  const saveProfile = () => {
    var roles =[];
    if (selectedUserRole.value===undefined){
      roles[0]=selectedUserOptionalRole?.value?.value;
    }
    else{
     roles[0]=selectedUserRole?.value?.value;
     if(selectedUserOptionalRole?.value?.value !== "" && selectedUserOptionalRole?.value?.value !== undefined 
      && selectedUserOptionalRole?.value?.value !== "none") {
      roles[1] =selectedUserOptionalRole?.value?.value;
     }
    }
    handleUserGroupMemberSettings();
    userDetail.firstName = firstName !== "" ? firstName : userDetail?.firstName;
    userDetail.lastName = lastName !== "" ? lastName : userDetail?.lastName;
    userDetail.email = email !== "" ? email : userDetail?.email;
    userDetail.title = title !== "" ? title : userDetail?.title;
    userDetail.roleSet = {};
    userDetail.roleSet.roleTypes = roles;
    userDetail.userGroupMembers = userGroup;
    userDetail.userLanguages = defaultSelectedReview;
    userDetail.userLanguagePairs = userLangPair
    var payload = transformBlankToNull(userDetail);
    const handleResponse = (res) => {
      if (!(res?.data?.data?.body?.errors?.userGroupMembers || res?.data?.handledMessage)) {
        setHasError(false);
        setErrorMessage('');
        changeclass(!addclass);
        getFullUserById();
      } else {
        setHasError(true);
        setErrorMessage(res?.data?.data?.body?.errors?.userGroupMembers || res?.data?.handledMessage);
      }
    };
    if (!roleArray.includes('ROLE_VENDOR')) {
      postAxiosResponse(APIUrls.GET_FULL_USER_BY_ID(userId), payload).then(handleResponse);
    } else {
      postAxiosResponse(APIUrls.GET_FULL_USER_BY_ID_VENDOR(userId), payload).then(handleResponse);
    }
    $('button.active').trigger('focus');
  };

  const verifyWithPassword = () => {
    showModel();
  }

  const resendCode = () => {
    postAxiosResponse(APIUrls.VERIFY_EMAIL, transformBlankToNull(prop.user.resource))
    .then((res) => {
      if(!(res.data.data.body.success)) {
        setCodeResent(true);
      }
    })
  }

  const cancelEmailUpdateRequest = (e) => {
    deleteAxiosResponse(APIUrls.VERIFY_EMAIL)
    .then((res) => {
      if(res.data.data.body.success) {
        handleCancel(e);
      }
    })
  }

  const setVerificationCodeAndUpdateError = (value) => {
    setVerificationCode(value);
    setVerificationCodeError(false);
  }

  const verifyWithCode = () => {
    let payload = {
      id : -1,
      status: false
    }
    putAxiosResponse(APIUrls.VERIFY_EMAIL_WITH_CODE+`?emailCode=`+verificationCode, payload)
    .then((res) => {
      if(res.data.data.success) {
        setShowEmailChangeConfirmation(true);
        showModel();
      } else {
        setVerificationCodeError(true);
      }
    })
  }

  const redirectToTab = (tab,editMode) =>{
    prop.redirectTab(tab)
  }
  const submitPasswordAction = () => {
    let payload = {
      action: "GENERATE",
      password : password
    }
    postAxiosResponse(APIUrls.VERIFY_EMAIL_WITH_PASSWORD, payload)
    .then((res) => {
      if(res.data.data.statusCodeValue === 400) {
        setInvalidPasswordError(true)
      }
      if(res.data.data.statusCodeValue === 200) {
        if(!(res?.data?.data?.body?.success)) {
          setSuccessErrors(true);
          let errorBody = res?.data?.data?.body
          if(errorBody.inUseError) {
            setSuccessErrorMsg("Your company is already registered with " + customerData?.brand + ".  We can help you become a user of this account by contacting us at sales@cloudwords.com</a> or at +1 (415) 394-8000 for further assistance.");
          }
          if(errorBody.domainClaimedError) {
            setSuccessErrorMsg("Your company is already registered with " + customerData?.brand + ".  We can help you become a user of this account by contacting us at sales@cloudwords.com or at +1 (415) 394-8000 for further assistance.");
          }
          if(errorBody.inValidAccess) {
            setSuccessErrorMsg("You have been removed from " + customerData?.brand + " by your account administrator.");
          }
        } else {
          setShowEmailChangeConfirmation(true);
        }
      }
    })
  }

  const handleOK = (e) => {
    hideModel();
    handleCancel(e);
  }

  const encodeAndSetPassword = (event) => {
    setInvalidPasswordError(false);
    setSuccessErrors(false);
    setPassword(encodePassword(event.target.value))
  }
  
$('.tooltip-container p').on('keydown', function(e){
  if(e.key === Constants.ESCAPE){
    if ($(this).attr('id') === "profileDepartment") {
      setRefs(profileDeptTooltipRef);
    }
    else if ($(this).attr('id') === "editProfileDepartment") {
      setRefs(editProfileDeptTooltipRef);
    }
    else if ($(this).attr('id') === "langToReview") {
      setRefs(langToReviewTooltipRef);
    }
    else if ($(this).attr('id') === "editLangToReview") {
      setRefs(editLangToReviewTooltipRef);
    }
    else if ($(this).attr('id') === "langToTranslate") {
      setRefs(langToTranslateTooltipRef);
    }
    else if ($(this).attr('id') === "editLangToTranslate") {
      setRefs(editLangToTranslateTooltipRef);
    }
  }
});

useEffect(()=>{
  if (refs.current) {
    refs.current.hideTooltip();
    setRefs({});
  }
}, [refs]);

  return (prop?.user?.userId=== undefined && prop?.user?.resource?.userId === undefined) ? (
    <div className={"gb-overlay show"}>
    <div className="gb-loader">
      <RotatingLines
        strokeColor="#0096FF"
        strokeWidth="5"
        width="196"
        visible={true}
      />
    </div>
    </div>
  ) : (
    <>
      <div
        className={
          addclass
            ? "profile-readonly-block hide"
            : "profile-readonly-block show"
        }
      >
        <div className="inner-heading flex">
          <div className="left">
            <h4>{translate("my_account.personal_information")}</h4>
           {!userDetail?.userSettingsComplete ?
            <div className="error-in-bids flex-center bid-alert-view-width"> 
                <div className="alert">
                 <p className="mb-0">Please <Link onClick={(e) => redirectToTab("preferences",true)}>configure</Link> your timezone and other region preferences for your profile.</p>
                </div>
              </div>
                : ''}
          </div>
          <div className="flex two-col">

            <ConditionalBlock condition={(parseInt(userId) === parseInt(owner.id) && !(userDetail?.azureSsoEnabled || userDetail?.samlEnabled || customerBootstrapData.authenticationType === 'WELOCALIZE_OKTA'))}>
                <button className="dashboard-btn" onClick={() => navigate('/change-password')}>Change Password</button>
            </ConditionalBlock>
            <button id="edit-btn" className="dashboard-btn" onClick={(e) => editclick(e)}>

              Edit
            </button>
          </div>
        </div>
        <div className="profile-info-details">
          <ul className="flex">
            <li>
              <label>{translate("my_account.first_name")}</label>
              <span>{userDetail.firstName}</span>
            </li>
            <li>
              <label>{translate("my_account.last_name")}</label>
              <span>{userDetail.lastName}</span>
            </li>
            <li>
              <label>{translate("my_account.title")}</label>
              <span>{userDetail.title}</span>
            </li>
            <li>
              <label>Email</label>
              {companyEmail ? 
                (<span>
                    <strong>{userDetail.firstName},</strong> {translate("my_account.enter_your_company_details")} <Link onClick={(e) => editclick(e)}>{translate("my_account.company_email")}</Link>
                  </span>
                ) : <></>
              }
              {
                verifyEmail ?
                (
                  <span
                    role="button"
                    aria-label="error"
                    className="alert-icon mar-bot14"
                  >
                    <strong>{userDetail.firstName},</strong> Thanks for providing your company email. Check {userDetail?.requestedEmail} for your verification code. <a onClick={(e) => editclick(e)}>Verify now</a>
                  </span>
                ) : <></>
              }
              <span>{userDetail.email}</span>
            </li>
          </ul>
          
        </div>
        
        {selectedUserOptionalRole?.value?.value !==
          "ROLE_VENDOR" ?(
        <div className="role-and-department">
          <h5 className="heading-width-border">
          {translate("my_account.role_languages_departments")}          </h5>
          <ul className="role">
            <li>
              <label>
              {translate("my_account.role")}<Link onClick={()=>openNewTab("https://cloudwords.zendesk.com/hc/en-us/articles/206359183-What-Are-The-Roles-Available-on-Cloudwords-Accounts")} ><a>{translate("my_account.learn_more")}</a></Link>
              </label>
              <span>{userDetail?.roleSet?.displayName}</span>
            </li>
          </ul>
          { selectedUserOptionalRole?.value?.value !==
          "ROLE_VENDOR" ?(
          <div className="profile-department">
            <div className="tooltip-container">
              <h6>{translate("my_account.department")}</h6>
              <p
                className="inline-flex ml-6 gb-focus"
                tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                data-padding="10px 10px 10px 10px"
                data-place="right"
                data-tip={Constants.SETTINGS_DEPT_TOOLTIP}
                data-for="settings-dept-tooltip"
                id="profileDepartment"
                aria-label="Tooltip"
              >
                <svg
                  className="svg-tooltip-icon m-0"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                </svg>
                <div className="font-zero">{Constants.SETTINGS_DEPT_TOOLTIP}</div>
              </p>
              <ReactTooltip
                className="tooltip"
                id="settings-dept-tooltip"
                role="tooltip"
                ref={profileDeptTooltipRef}
              ></ReactTooltip>
            </div>
            <div className="table-responsive global-table">
              <table className="sortable">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    {selectedUserRole?.value?.value !==
                      "ROLE_CUSTOMER_PROJECT_REQUESTER" ||
                    selectedUserOptionalRole?.value?.value ===
                      "ROLE_CUSTOMER_REVIEWER" ? (
                      <>
                        <th>{translate("my_account.available_as_project_follower")}</th>
                        <th>{translate("my_account.automatically_follow_projects")}</th>
                        {selectedUserRole?.value?.value ===
                          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
                        selectedUserOptionalRole?.value?.value ===
                          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? (
                          <th>Available as Internal Translator</th>
                        ) : null}
                      </>
                    ) : (
                      <>
                        <th></th>
                        <th></th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {userGroup?.map((department, index) => {
                    return (
                      <tr key={index}>
                        <td>{department?.userGroup?.name || department?.label || department?.userGroup?.label}</td>
                        {selectedUserRole?.value?.value !==
                          "ROLE_CUSTOMER_PROJECT_REQUESTER" ||
                        selectedUserOptionalRole?.value?.value ===
                          "ROLE_CUSTOMER_REVIEWER" ? (<><td>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={`includeInFollowersList-${index}`}
                              id={`includeInFollowersList-${index}`}
                              disabled
                              checked={department.includeInFollowersList}
                              
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`includeInFollowersList-${index}`}
                            ></label>
                          </div>
                        </td>
                        <td>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={`defaultFollowAllProjects-${index}`}
                              id={`defaultFollowAllProjects-${index}`}
                              disabled
                              checked={
                                department.defaultFollowAllProjects
                              }
                              
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`defaultFollowAllProjects-${index}`}
                            ></label>
                          </div>
                        </td>
                        {selectedUserRole?.value?.value ===
                              "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
                            selectedUserOptionalRole?.value?.value ===
                              "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? <td>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={`availableAsInternalTranslator-${index}`}
                              id={`availableAsInternalTranslator-${index}`}
                              disabled
                              checked={
                                department.availableAsInternalTranslator
                              }
                              
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`availableAsInternalTranslator-${index}`}
                            ></label>
                          </div>
                        </td> : null}
                        </>) : (
                          <>
                          <td></td>
                          <td></td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>) : null}
        </div>) : null}

        {
        selectedUserOptionalRole?.value?.value !== "ROLE_VENDOR" && selectedUserRole?.value?.value !== "ROLE_CUSTOMER_QUOTE_APPROVER" 
        && selectedUserRole?.value?.value !== "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? (
        <div className="role-and-department mar-bot16">
          <div className="tooltip-container bids-tooltip flex-align-center">
            <h5 className="heading-width-border"> {translate("my_account.languages_review")}</h5>
            <p
              className="inline-flex ml-6 gb-focus"
              tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
              data-padding="10px 10px 10px 10px"
              data-place="right"
              data-tip={Constants.MY_ACCT_LANG_TO_REVIEW_TOOLTIP}
              data-for="lang-review-readonly"
              id="langToReview"
              aria-label="Tooltip"
              >
              <svg
                className="svg-tooltip-icon m-0"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
              </svg>
              <div className="font-zero">{Constants.MY_ACCT_LANG_TO_REVIEW_TOOLTIP}</div>
            </p>
            <ReactTooltip
              className="tooltip"
              id="lang-review-readonly"
              role="tooltip"
              ref={langToReviewTooltipRef}
            >
            </ReactTooltip>
          </div>
          {defaultSelectedReview.length !== 0 ? (
            <ul className="role flex btn-gap">
              {defaultSelectedReview?.map((langs, index) => {
                return <li key={index}>
                  {defaultSelectedReview.length === index + 1 ? <span>{langs.display}</span> : <span>{langs.display},</span>}
                </li>
              })}
            </ul>
          ) : (
            <ul className="role">
              <li>
                <span>None Selected</span>
              </li>
            </ul>
          )}
        </div>): null}

        {selectedUserRole?.value?.value ===
          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
        selectedUserOptionalRole?.value?.value ===
          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? (
        <div className="role-and-department">
          <div className="tooltip-container bids-tooltip  flex-align-center">
            <h5 className="heading-width-border">Language Pairs to Translate</h5>
            <p
              className="inline-flex ml-6 gb-focus"
              tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
              data-padding="10px 10px 10px 10px"
              data-place="right"
              data-tip={Constants.MY_ACCT_LANG_PAIRS_TO_TRANSLATE}
              data-for="lang-pair-readonly"
              id="langToTranslate"
              aria-label="Tooltip"
            >
              <svg
                className="svg-tooltip-icon m-0"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
              </svg>
            </p>
            <ReactTooltip
              className="tooltip"
              id="lang-pair-readonly"
              role="tooltip"
              ref={langToTranslateTooltipRef}
            >
            </ReactTooltip>
          </div>
          {userLangPair?.length !== 0 ? (
            <ul className="role btn-gap">
              {displayUserLangPair?.map((langs, index) => {
                return (
                  <li key={index}>
                    <span>
                      {langs.source.display} to{" "}
                      {langs.target.map((target, indx) => {
                        if (langs.target.length === indx + 1) {
                          return target.display;
                        } else {
                          return target.display + ", ";
                        }
                      })}
                    </span>
                    {}
                  </li>
                );
              })}
            </ul>
          ) : (
            <ul className="role">
              <li>
                <span>None Selected</span>
              </li>
            </ul>
          )}
        </div>) : null}

      </div>
      <div
        className={
          addclass
            ? "profile-editonly-block show"
            : "profile-editonly-block hide"
        }
      >
        <h5 className="heading-width-border">Personal Information</h5>
        <div className="profile-edit-form mar-bot14">
          <div className="flex wrap-dropdown">
            <div className="global-dropdown-block flex-center">
              <label htmlFor="firstName">{translate("my_account.first_name")}</label>
              <input
                id="firstName"
                type="text"
                className="form-control-sm"
                placeholder="First Name"
                defaultValue={userDetail.firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="global-dropdown-block flex-center">
              <label htmlFor="userDetailLastName">{translate("my_account.last_name")}</label>
              <input
                id="userDetailLastName"
                type="text"
                className="form-control-sm"
                placeholder="Last Name"
                defaultValue={userDetail.lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <div className="flex wrap-dropdown">
            <div className="global-dropdown-block flex-center">
              <label htmlFor="userDetailEmail">{translate("my_account.email")}</label>
              <input
                id="userDetailEmail"
                type="text"
                className="form-control-sm"
                defaultValue={userDetail.email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {companyEmail ?
                <div className="flex wrap-dropdown">
                  <div className="global-dropdown-block flex-center">
                    <span
                      aria-label="error"
                      className="alert-icon mar-bot14"
                    >
                      {prop.user.resource.firstName} {translate("my_account.request_pricing")}
                    </span>
                  </div>
                </div> : <></>
              }
            </div>
            <div className="global-dropdown-block flex-center">
              <label htmlFor="userDetailTitle">{translate("my_account.title")} <span>Optional</span></label>
              <input
                id="userDetailTitle"
                type="text"
                className="form-control-sm"
                defaultValue={userDetail.title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
          {verifyEmail ? <><div className="flex wrap-dropdown">
            <span
              role="button"
              aria-label="error"
              className="alert-icon mar-bot14"
              tabIndex="0"
            >
              Enter verification code sent to {userDetail?.requestedEmail}
            </span>
          </div>
          {verificationCodeError && <div className="flex">
            <p className="error-alert">Invalid verification code</p>
          </div>}
          <div className="flex btn-gap mar-bot10">
            <div className="global-dropdown-select">
              <input id="verification-code" type="text" className="form-control-sm" onChange={(event) => setVerificationCodeAndUpdateError(event.target.value)}/>
            </div>
            <div className="flex btn-gap">
              <button className="blue-btn" id="verify-button" onClick={verifyWithCode}>Verify with Code</button>
              <ConditionalBlock condition={!(userDetail?.azureSsoEnabled || userDetail?.samlEnabled || customerBootstrapData.authenticationType === 'WELOCALIZE_OKTA')}>
                <button className="blue-btn" id="verify-without-code" onClick={verifyWithPassword}>Verify with Password</button>
              </ConditionalBlock>
            </div>
          </div>
          <div className="flex btn-gap">
            {codeResent ? <p id="verify-code-resent" className="m-0">Verification code resent</p> : <a href="#" id="resend-link" onClick={resendCode}>Resend</a>}
            |<a href="#" id="cancel-request-link" onClick={(e) => cancelEmailUpdateRequest(e)}>Cancel</a>
          </div>
          </> : <></>}
        </div>

        {selectedUserOptionalRole?.value?.value !==
          "ROLE_VENDOR" ?(
        <div className="role-and-department">
          <h5 className="heading-width-border">
            {translate("my_account.role_languages_departments")}
          </h5>
          <div className="profile-edit-form">
            <div className="flex wrap-dropdown">
              {ownerRole === "ROLE_CUSTOMER" && userPermissions.includes("ADMINISTRATION") ? (
                <div className="global-dropdown-block flex-center">
                  <label>            {translate("my_account.role")}
</label>

                  <Select
                    className="global-dropdown-select"
                    classNamePrefix='cw'
                    menuShouldScrollIntoView={false}
                    closeMenuOnSelect={true} 
                    role="listbox"
                    aria-label="Role"
                    placeholder="Role"
                    options={userRole}
                    onChange={(value) => filterUsers(value)}
                    value={userRole.filter(function (role) {
                      return role?.value?.value === selectedUserRole?.value?.value;
                    })}
                  />
                </div>) : 
                (<ul className="role">
                  <li>
                    <label>
                      Role <a href="https://help.cloudwords.com/hc/en-us/articles/206359183-What-Are-The-Roles-Available-on-Cloudwords-Accounts">Learn more</a>
                    </label>
                    <span>{userDetail?.roleSet?.displayName}</span>
                  </li>
                </ul>)
                }
              {!hideOptionalRole && selectedUserRole?.value?.value !== "ROLE_CUSTOMER_QUOTE_APPROVER" && ownerRole === "ROLE_CUSTOMER" && userPermissions.includes("ADMINISTRATION") ? (
                <div className="global-dropdown-block flex-center">
                  <label>
                    {translate("my_account.add_another_role")} <span>(Optional)</span>
                  </label>
                  <Select
                    className="global-dropdown-select"
                    classNamePrefix='cw'
                    menuShouldScrollIntoView={false}
                    closeMenuOnSelect={true}
                    role="listbox"
                    id="addAnotherRole"
                    options={userOptionalRole}
                    aria-label="Add Another role Optional"
                    onChange={(value) => filterOptionalUser(value)}
                    value={userOptionalRole.filter(function (role) {
                      return role?.value?.value === selectedUserOptionalRole?.value?.value;
                    })}
                  />
                </div>
              ) : null}
            </div>
          </div>

          <div className="profile-department">
            {customerBootstrapData?.features?.USER_GROUPS ? <div className="tooltip-container">
              <h6>{translate("my_account.department")}</h6>
              <p
                className="inline-flex ml-6 gb-focus"
                tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                data-padding="10px 10px 10px 10px"
                data-place="right"
                data-tip={Constants.SETTINGS_DEPT_TOOLTIP}
                data-for="settings-dept-tooltip"
                id="editProfileDepartment"
                aria-label="Tooltip"
              >
                <svg
                  className="svg-tooltip-icon m-0"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                </svg>
                <div className="font-zero">{Constants.SETTINGS_DEPT_TOOLTIP}</div>
              </p>
              <ReactTooltip
                className="tooltip"
                id="settings-dept-tooltip"
                role="tooltip"
                ref={editProfileDeptTooltipRef}
                ></ReactTooltip> &nbsp;
            {hasError && <label className="department-error-message"> {errorMessage} </label>}
            </div> : <div className="mar-bot10"><h6>Project Followers</h6></div>}
            {ownerRole === Constants.ROLE_CUSTOMER_ADMIN && customerBootstrapData?.features?.USER_GROUPS && <div className="global-dropdown-block flex-center">
              <Select className="global-dropdown-select" classNamePrefix='cw'
                name="Department"
                aria-label="Department"
                placeholder="Select department"
                options={filteredDepartments}
                onChange={(value) => handleDepartmentSelection(value)}
                value={{
                  label: "--Select a department--",
                  value: Constants.BLANK,
                }}
              ></Select></div>}
              {!userGroup.length && <p>This user has not been assigned to any department.</p>}
            {userGroup.length !== 0 && <div className="table-responsive global-table">
              <table className="sortable" aria-label="Department">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    {selectedUserRole?.value?.value !==
                      "ROLE_CUSTOMER_PROJECT_REQUESTER" ||
                    selectedUserOptionalRole?.value?.value ===
                      "ROLE_CUSTOMER_REVIEWER" ? (
                      <>
                        <th>Available as project follower</th>
                        <th>Automatically follow projects</th>
                        {selectedUserRole?.value?.value ===
                          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
                        selectedUserOptionalRole?.value?.value ===
                          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? (
                          <th>Available as Internal Translator</th>
                        ) : null}
                      </>
                    ) : (
                      <>
                        <th></th>
                        <th></th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {userGroup?.map((department, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {selectedUserRole?.value?.value !==
                            "ROLE_CUSTOMER"  &&
                          selectedUserOptionalRole?.value?.value !==
                            "ROLE_CUSTOMER" && ownerRole === Constants.ROLE_CUSTOMER_ADMIN ? (
                            <div className="multiselect-output">
                              <button
                                key={index}
                                onClick={() =>
                                  removeDepartment(department)
                                }
                                aria-label={'remove ' + department?.userGroup?.name || department?.label || department?.userGroup?.label}
                              >
                                <strong>{department?.userGroup?.name || department?.label || department?.userGroup?.label}</strong>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="9"
                                  viewBox="0 0 10 9"
                                  fill="none"
                                >
                                  <path
                                    d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                    stroke="#213248"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                              </button>
                            </div>
                          ) : (
                            department?.userGroup?.name !== "Unassigned" ? department?.userGroup?.name : ""
                          )}
                        </td>
                        {selectedUserRole?.value?.value !==
                          "ROLE_CUSTOMER_PROJECT_REQUESTER" ||
                        selectedUserOptionalRole?.value?.value ===
                          "ROLE_CUSTOMER_REVIEWER" ? (
                          <>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={`includeInFollowersLists-${index}`}
                                  id={`includeInFollowersLists-${index}`}
                                  checked={department?.includeInFollowersList}
                                  disabled={
                                    selectedUserRole?.value?.value ===
                                      "ROLE_CUSTOMER_PROJECT_REQUESTER" &&
                                    selectedUserOptionalRole?.value?.value ===
                                      "ROLE_CUSTOMER_REVIEWER"
                                  }
                                  onChange={(e) =>
                                    setUserGroupAccessFollower(
                                      e,
                                      department,
                                      index
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`includeInFollowersLists-${index}`}
                                ></label>
                              </div>
                            </td>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={`defaultFollowAllProject-${index}`}
                                  id={`defaultFollowAllProject-${index}`}
                                  checked={department?.defaultFollowAllProjects}
                                  disabled={
                                    selectedUserRole?.value?.value ===
                                      "ROLE_CUSTOMER_PROJECT_REQUESTER" &&
                                    selectedUserOptionalRole?.value?.value ===
                                      "ROLE_CUSTOMER_REVIEWER"
                                  }
                                  onChange={(e) =>
                                    setUserGroupAccessAutomaticFollower(
                                      e,
                                      department
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`defaultFollowAllProject-${index}`}
                                ></label>
                              </div>
                            </td>
                            {selectedUserRole?.value?.value ===
                              "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
                            selectedUserOptionalRole?.value?.value ===
                              "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? (
                              <td>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name={`availableAsInternalTranslator-${index}`}
                                    id={`translator-${index}`}
                                    checked={
                                      department?.availableAsInternalTranslator
                                    }
                                    disabled={
                                      selectedUserRole?.value?.value ===
                                        "ROLE_CUSTOMER_PROJECT_REQUESTER" &&
                                      selectedUserOptionalRole?.value?.value ===
                                        "ROLE_CUSTOMER_REVIEWER"
                                    }
                                    onChange={(e) =>
                                      setUserGroupAccessInternalTranslator(
                                        e,
                                        department
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`translator-${index}`}
                                  ></label>
                                </div>
                              </td>
                            ) : null}
                          </>
                        ) : (
                          <>
                            <td></td>
                            <td></td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>}
            <p>
            {translate("my_account.what_does_following_means")}
            </p>
          </div>
        </div>) : null}
        
        {selectedUserOptionalRole?.value?.value !==
          "ROLE_VENDOR" ?(
        <div className="role-and-department block-credential">
          <h5 className="heading-width-border">
            Reassignment of the project for blocked/locked customer's
            credential
          </h5>

          <div className="global-dropdown-block flex align-items">
            <label htmlFor="ProjectID">Project Id</label>
            <div className="flex align-items">
              <div className="global-dropdown-select mar-right24">
              <input
                type="text"
                className="form-control-sm"
                id="ProjectID"
                onChange={(e) => setProjectForBlockedUser(e.target.value)}
              />
            </div>
              <div
                className="global-dropdown-select mar-right24"
              >
                <Select
                  className="global-dropdown-select mb-0"
                  classNamePrefix='cw'
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  aria-label="Service Type"
                  placeholder="Service Type"
                  options={serviceType}
                  onChange={(value) => selectServiceType(value)}
                  value={serviceType.filter(function (role) {
                    return role.value === selectedUserRole.value;
                  })}
                />
              </div>
              <div
                className="global-dropdown-select"
                aria-label="Users"
              >
                <button className="drop-down-btn gb-dropBtn">
                  <span>Users</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="#ABB5BE"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
                <div className="global-dropdown">
                  <ul>
                    <li>Select one</li>
                    <li>Select two</li>
                    <li>Depart_3</li>
                    <li>Depart_4</li>
                    <li>Depart_5</li>
                  </ul>
                </div>
              </div>
              <button className="blue-btn">Save</button>
            </div>
          </div>
        </div> ): null }
        {(selectedUserRole?.value?.value ===
          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" &&
          selectedUserOptionalRole?.value?.value === "none") ||
        (selectedUserRole?.value?.value ===
          "ROLE_CUSTOMER_QUOTE_APPROVER") || (selectedUserOptionalRole?.value?.value ===
          "ROLE_VENDOR") ? null : (
          <div className="role-and-department lang-and-review">
            <div className="tooltip-container bids-tooltip flex-align-center">
            <h5 className="heading-width-border">Languages to Review</h5>
            <p
              className="inline-flex ml-6 gb-focus"
              tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
              data-padding="10px 10px 10px 10px"
              data-place="right"
              data-tip={Constants.MY_ACCT_LANG_TO_REVIEW_TOOLTIP}
              data-for="lang-review-readonly"
              id="editLangToReview"
              aria-label="Tooltip"
              >
              <svg
                className="svg-tooltip-icon m-0"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
              </svg>
              <div className="font-zero">{Constants.MY_ACCT_LANG_TO_REVIEW_TOOLTIP}</div>
            </p>
            <ReactTooltip
              className="tooltip"
              id="lang-review-readonly"
              role="tooltip"
              ref={editLangToReviewTooltipRef}
            >
            </ReactTooltip>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="checkbox"
                id="chk30"
              />
              <label className="form-check-label" htmlFor="chk30">
                Apply to all campaigns and open projects
              </label>
            </div>
            <div className="flex wrap-dropdown">
              <div className="global-dropdown-block flex-center">
                <div
                  className="global-dropdown-select"
                >
                  <Select
                    className="global-dropdown-select"
                    classNamePrefix='cw'
                    menuShouldScrollIntoView={false}
                    inputProps={{autoComplete: 'off'}}
                    closeMenuOnSelect={true}
                    aria-label="Target Language"
                    placeholder="Target Language"
                    options={allTargetLangs}
                    onChange={(value) => selectTargetLangReview(value)}
                    value={targetLangReview.filter(function (target) {
                      return (
                        target.value.language ===
                        selectedTargetLangReview.language
                      );
                    })}
                  />
                </div>
              </div>
            </div>
            <div className="multiselect-output flex mar-bot16">
              {defaultSelectedReview?.map((langs, index) => {
                return (
                  <button key={index} onClick={() => removeLanguage(langs)} aria-label={"remove "+langs.display}>
                    <strong>{langs.display}</strong>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                    >
                      <path
                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                        stroke="#213248"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                );
              })}
            </div>
          </div>
        )}
       {selectedUserRole?.value?.value ===
          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ||
        selectedUserOptionalRole?.value?.value ===
          "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" ? (
          <div className="role-and-department block-credential mt-5">
            <div className="tooltip-container bids-tooltip flex-align-center">
            <h5 className="heading-width-border">
              Language Pairs to Translate
            </h5>
            <p
              className="inline-flex ml-6 gb-focus"
              tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
              data-padding="10px 10px 10px 10px"
              data-place="right"
              data-tip={Constants.MY_ACCT_LANG_PAIRS_TO_TRANSLATE}
              data-for="lang-pair-readonly"
              id="editLangToTranslate"
              aria-label="Tooltip"
              role="text"
            >
              <svg
                className="svg-tooltip-icon m-0"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
              </svg>
            </p>
            <ReactTooltip
              className="tooltip"
              id="lang-pair-readonly"
              role="tooltip"
              ref={editLangToTranslateTooltipRef}
            >
            </ReactTooltip>
            </div>
            <div
              className={
                updated
                  ? "multiselect-output flex mar-bot16"
                  : "multiselect-output flex mar-bot16 langs"
              }
            >
              <ul>
                {displayUserLangPair?.map((langs, index) => {
                  return (
                    <React.Fragment key={index}>
                      <li className="flex mar-bot16">
                        <span
                          style={{
                            padding: "6px 9px 6px 10px",
                            margin: "10px 8px 0 0",
                          }}
                        >
                          from
                        </span>{" "}
                        <button className="pairFromBtn" onClick={() => removeLanguagePairSource(langs)}
                          aria-label={"remove "+langs.source.display}
                        >
                          <strong>{langs.source.display}</strong>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                          >
                            <path
                              d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                              stroke="#213248"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                        </button>{" "}
                        <span
                          style={{
                            padding: "6px 9px 6px 10px",
                            margin: "10px 8px 0 0",
                          }}
                        >
                          to
                        </span>{" "}
                        {"  "}
                        {langs.target.map((target, indx) => {
                          return (
                            <button
                              key={indx}
                              onClick={() =>
                                removeLanguagePairTarget(langs, target)
                              }
                              aria-label={"remove "+target?.display}
                            >
                              <strong>{target?.display}</strong>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="9"
                                viewBox="0 0 10 9"
                                fill="none"
                              >
                                <path
                                  d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                  stroke="#213248"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </button>
                          );
                        })}
                        <div
                          className="flex-center"
                          role="button"
                          aria-label="Single Assignee"
                          // aria-expanded={assigneeListExpanded}
                        >
                          <span className="blue-btn align-center"
                            tabIndex="0"
                            onClick={(e) => selectTargetLang(e, langs, index)}
                            onKeyDown={(e) => selectTargetLangKeydown(e, langs, index)}
                            style={{
                              margin: "10px 8px 0 0",
                            }}
                          >
                            Add New
                          </span>
                        </div>
                        <div className="relative">
                          <div
                            className={
                              showTargetLang === index
                                ? "popover-body show-assignee-dropdown setTop"
                                : "popover-body assignee-dropdown setTop"
                            }
                          >
                            <div className="triangle-with-shadow"></div>
                            <div className="inner-popover maxHeight210">
                              <h4>Target Languages</h4>
                              <div className="group-radio-list">
                                {targetLanguages.map((lang, indx) => {
                                  return (
                                    <div
                                      className="radio-form-check"
                                      key={indx}
                                    >
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        id={indx + "-" + index}
                                        value={lang.value.code}
                                        checked={
                                          lang.value.language + "-" + index ===
                                          selectedLanguagecode
                                        }
                                        onChange={(event) =>
                                          selectNewTargetLang(lang, langs)
                                        }
                                      />
                                      <label
                                        className="form-check-label m-0 wrapInherit"
                                        htmlFor={indx + "-" + index}
                                      >
                                        {lang.label}
                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
            <div className="global-dropdown-block flex-center">
              <div className="flex">
                <div
                  className="global-dropdown-select mar-right24"
                >
                  <Select
                    className="global-dropdown-select"
                    classNamePrefix='cw'
                    menuShouldScrollIntoView={false}
                    closeMenuOnSelect={true}
                    aria-label="Source Language"
                    placeholder="Source Language"
                    options={sourceLanguage}
                    onChange={(value) => selectNewSourceLang(value)}
                    value={sourceLanguage.filter(function (role) {
                      return role?.value === selectedSourceLang?.value;
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {addclass ? (
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
          <div className="left flex">
            <div>
              <button className="btn-default" onClick={(e) => handleCancel(e)}>
                Cancel
              </button>
            </div>
            <div>
              <button className="btn-default" onClick={saveProfile}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      ) : null}
      <div id="modelPopup" className="lightbox-panel">
        <div className="inner-lightbox-panel pb-0">
          <div className="modal-header flex padd-lr">
            {!showEmailChangeConfirmation && <strong>Please confirm your password</strong>}  
            {showEmailChangeConfirmation && <strong>{userDetail.requestedEmail + " has been verified."}</strong>}
          </div>
          <div className="lightbox-content padd-22 vender-form-block">
            <div>
              {!showEmailChangeConfirmation && <div className="flex wrap-dropdown m-0">
                <div className="global-dropdown-block flex-center mar-bot14">
                  <label>Email</label>
                  <p>{prop.user.resource.email}</p>
                  <label>Password</label>
                  {invalidPasswordError && <p className="error-alert">Incorrect password</p>}
                  {successErrors && <p className="error-alert">{`${successErrorMsg}`}</p>}
                  <div className="global-dropdown-select">
                    <input type="password" onChange={(event) => encodeAndSetPassword(event)}/>
                  </div>
                </div>
              </div>}
              {showEmailChangeConfirmation && <div className="vender-form-block">
                From now on please use {prop.user.resource.requestedEmail} as your username when logging in.
              </div>}
            </div>
          </div>
          <div className="modal-footer modal-footer-border flex px-22">
            {!showEmailChangeConfirmation && <><button className="btn btn-bold" id="submit-password-prompt-btn" onClick={submitPasswordAction}>
              Submit
            </button>
            <button className="btn btn-bold set-right" id="cancel-password-prompt-btn" onClick={hideModel}>
              Cancel
            </button></>}
            {showEmailChangeConfirmation && <button className="btn btn-bold set-right" id="confirm-ok" onClick={(e) => handleOK(e)}>
              OK
            </button>}
          </div>
        </div>
      </div>
    </>
  );
}
